import { createSelector } from "reselect";
// import { reduceWalletForAssetType } from "../../services/utility/utils";

export const selectAuth = (state) => state.auth;

export const selectWallet = (assetType, accountType) =>
  createSelector(selectAuth, (authState) => {
    // return authState.accounts.reduce(reduceWalletForAssetType(assetType, accountType, 'balance'), 0);
  });


export const selectWallets = createSelector(
  selectAuth,
  authState => {
    return authState.accounts.reduce((acc, { assetType, accountType, balance = 0, pendingWithdrawals = 0 }) => {
      if (accountType === 'Player' || accountType === 'Bonus') {
        const key = `${assetType.toLowerCase()}${accountType}`;
        let label = accountType === 'Player' ? assetType : 'BONUS';
        acc.push({ key, type: accountType, wallet: assetType, label, amount: balance - pendingWithdrawals });
      }
      return acc;
    }, []);
  }
);

export const selectAuthField = (field) => createSelector(selectAuth, (authState) => authState[field]);
